var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoteOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.094,
    height: 78.75,
    viewBox: "0 0 136.094 78.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Open",
    "data-name": "\" Open",
    d: "M32.344,28.313h41.25l-14.375,78.75H7.969Zm70.313,0h41.406l-14.531,78.75H78.438Z",
    transform: "translate(-7.969 -28.313)",
    fill: "#fff",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteOpen);
export default __webpack_public_path__ + "static/media/quote-open.1ff45d94a7757b4a18f0bb5b9bfadde9.svg";
export { ForwardRef as ReactComponent };